'use strict'
var lowlight = require('lowlight')
var createPlugin = require('./core')

module.exports = createPlugin(lowlight)



//////////////////
// WEBPACK FOOTER
// ./node_modules/rehype-highlight/index.js
// module id = +baF
// module chunks = 0